import PropTypes from 'prop-types';
import { Title } from 'smartsuite-ui';

function PageWrapper({ children, instructions, isLandingPage, title }) {
    return (
        <div className="page-wrapper">
            {title && (
                <Title cssClassModifiers={isLandingPage ? [] : ['size-medium']}>
                    {title}
                </Title>
            )}
            <span className="page-wrapper__instructions">{instructions}</span>
            {children}
        </div>
    );
}

PageWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    isLandingPage: PropTypes.bool,
    title: PropTypes.string,
};

PageWrapper.defaultProps = {
    isLandingPage: false,
    instructions: '',
};

export default PageWrapper;
